import { Component, OnInit } from '@angular/core';
import {
  DetailSearchConfiguration,
  OmniApi,
  SearchRequest,
  TranslationService,
  Session,
} from 'src/app/my-sedgwick';
import {
  BaseComponent,
  LoadingState,
  MessageBus,
  NewClaim,
  UserActionService,
} from 'src/app/shared';
import { TranslationRequest } from 'src/app/shared/models/translation/translation-request';
import { UserActions } from 'src/app/shared/models/user';

@Component({
    selector: 'app-new-claims-page',
    template: `
    <app-section>
      <div class="app-pl2 tw-w-full">
        <app-claim-breadcrumb></app-claim-breadcrumb>
      </div>
      <app-panel
        [title]="'New claims'"
        [headerLevel]="1"
        class="tw-w-full"
        [canExpand]="false"
      >
        <div class="tw-pb-2 app-color-input-grey tw-text-base">
          {{ 'New claims past 30 days' | translation: translationRequest }}
        </div>
        <div class="tw-min-h-[510px] tw-w-full">
          <app-detail-search-form
            #searchForm
            [config]="config"
            (search)="search($event)"
            [loading]="loading"
            [translationRequest]="translationRequest"
          >
            <ng-template #results>
              <app-search-count-row
                [count]="newClaims.length"
                [isInDirectInclude]="isInDirectReporting"               
                [supervisorFullName]="SupervisorFullName"
                [isSupervisor]="isSupervisorSelect"
              ></app-search-count-row>
              <app-new-claims
                [newClaims]="newClaims"
                class="tw-w-full"
                (export)="searchForm.appendExport($event)"
                [translationRequest]="translationRequest"
              />
            </ng-template>
          </app-detail-search-form>
        </div>
      </app-panel>
    </app-section>
  `,
    styles: ``,
    standalone: false
})
export class NewClaimsPageComponent extends BaseComponent implements OnInit {
  config = new DetailSearchConfiguration();

  mgrAction: UserActions | null;

  newClaims: NewClaim[];

  count: number;

  loading: LoadingState;

  request: SearchRequest;

  isSupervisorSelect : boolean = false;
  SupervisorFullName : string = '';
  isInDirectReporting : boolean = true;
  

  translationRequest = new TranslationRequest({
    language: sessionStorage.getItem('languagepreference'),
    key: null,
    contNum: 0,
    tableName: null,
    primaryKey: null,
    primaryValue: null,
    lob: null,
    group: 'Search',
    subGroup: 'Search',
  });

  constructor(
    private omniApi: OmniApi,
    private userAction: UserActionService,
    private messageBus: MessageBus,
    private translationService: TranslationService,
    private session: Session
  ) {
    super();
    this.config.key = 'omni-dashboard:new-claims';
    this.config.ssn.visible = false;
    this.config.supervisor.visible = false;
    this.config.includeIndirect.visible = false;
    this.config.employeeId.widthPercent = 25;
    this.config.initialSearch = true;
    this.config.initialSearchResultsOnClear = true;
    this.config.managerLookupSupervisor = false;
    this.config.showParametersToggle = true;
    this.config.expanded = false;
    this.config.status.visible = false;
    this.config.payType.visible = false;
  }

  async ngOnInit() {
    this.loadTranslations();
    this.mgrAction = UserActions.ViewOwnMgrDb;
    this.userAction.setAction(this.mgrAction);
    
    if(this.verifyFilterByManager())
    {
      this.isSupervisorSelect = this.verifyFilterByManager();
       const filteredManagerInSession = sessionStorage.getItem(
        this.session.user.sessionId + 'filteredManager_summary');
      const supervisor = JSON.parse(filteredManagerInSession);
      this.SupervisorFullName = supervisor.name;
      this.isInDirectReporting = this.verifyIndirectReport();
    }

    this.subs.sink = this.messageBus.topic('alert-action').subscribe(() => {
      this.search(this.request);
    });

  }

  loadTranslations(): void {
    this.translationRequest.contNum = Number(this.session.user.contNum);
    this.translationService.getTranslation(this.translationRequest);
  }

  override ngOnDestroy(): void {
    this.config.initialSearch = true;
  }

  async search(request: SearchRequest) {
    this.request = request;
    this.loading = 'Loading';

    const searchParam  = request.getParameters();
   
    if(this.verifyFilterByManager())
    {      
       const filteredManagerInSession = sessionStorage.getItem(
        this.session.user.sessionId + 'filteredManager_summary');
      const supervisor = JSON.parse(filteredManagerInSession);
      searchParam.supervisor = supervisor;
      searchParam.managerEmpUnum = supervisor.empUnum;
    }
    else{
      searchParam.supervisor = null;
      searchParam.managerEmpUnum = null;
    }

     if (this.verifyIndirectReport()) {
      const includeIndirectsInSession = sessionStorage.getItem(
        this.session.user.sessionId + 'includeIndirects_summary'
      );
      searchParam.includeIndirectReports = includeIndirectsInSession.toLowerCase() == 'true';
    }
    else {
      searchParam.includeIndirectReports = false;
    }
     
    
    this.newClaims = await this.omniApi.getNewClaims(searchParam);
    this.loading = this.newClaims.length > 0 ? 'Loaded' : 'Empty';
    this.config.initialSearch = false;
  }

  verifyFilterByManager() {
    const filteredManagerInSession = sessionStorage.getItem(
      this.session.user.sessionId + 'filteredManager_summary'
    );

    if (filteredManagerInSession == undefined || filteredManagerInSession == null || filteredManagerInSession.length < 2) {
      return false;
    }
    else {
      return true;
    }
  }

  verifyIndirectReport() {
    const includeIndirectsInSession = sessionStorage.getItem(
      this.session.user.sessionId + 'includeIndirects_summary'
    );

    if (includeIndirectsInSession == undefined || includeIndirectsInSession == null || includeIndirectsInSession.length < 2) {
      return false;
    }
    else {
      return includeIndirectsInSession == 'true';
    }
  }

}
